(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/campaign-utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/campaign-utils.js');
"use strict";


const CAMPAIGN_STORAGE_KEY = 'lyckoplatsenCampaign';
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const hasItems = _ref => {
  var _response$items;
  let {
    response
  } = _ref;
  return Boolean(response === null || response === void 0 || (_response$items = response.items) === null || _response$items === void 0 ? void 0 : _response$items.length);
};
const hasWagers = _ref2 => {
  var _response$wagers;
  let {
    response
  } = _ref2;
  return Boolean(response === null || response === void 0 || (_response$wagers = response.wagers) === null || _response$wagers === void 0 ? void 0 : _response$wagers.length);
};
const showCampaignNotAvailableDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title: 'Tyvärr kan du inte ta del av det här erbjudandet',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Eftersom du redan har spelat hos oss gäller inte nykundserbjudandet för dig. Du är varmt välkommen att spela ändå, men utan välkomstgåva.'
    }],
    actions: [{
      title: 'Till startsidan',
      callback: () => {
        dialog.close(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('lyckoplatsenHome'));
        });
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const hasCampaignRecord = async () => {
  const storedCampaignData = await svs.tur.apiCaller.drawgames.getPlayerObjectstore({
    keys: CAMPAIGN_STORAGE_KEY
  });
  return hasItems(storedCampaignData);
};
const runCampaignEligibilityCheck = async (check, errorMessage) => {
  try {
    return await check();
  } catch (error) {
    svs.lyckoplatsen.logger.error(errorMessage, error);
    return false;
  }
};
const hasActiveOrFinishedWagers = async () => {
  const productId = productMapping.getProductWagersId(productMapping.CONSTANTS.LYCKOPLATSEN);
  const [userHasActiveWagers, userHasFinishedWagers] = await Promise.all([runCampaignEligibilityCheck(async () => {
    const activeWagers = await svs.tur.apiCaller.drawgames.getPlayerActiveWagers({
      productId,
      count: 1
    });
    return hasWagers(activeWagers);
  }, 'Failed to validate active campaign wagers'), runCampaignEligibilityCheck(async () => {
    const finishedWagers = await svs.tur.apiCaller.drawgames.getPlayerFinishedWagers({
      productId,
      count: 1
    });
    return hasWagers(finishedWagers);
  }, 'Failed to validate finished campaign wagers')]);
  return userHasActiveWagers || userHasFinishedWagers;
};
const ensureNewCustomerCampaignEligibility = async () => {
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return true;
  }
  const [userHasWagers, userHasCampaignRecord] = await Promise.all([runCampaignEligibilityCheck(hasActiveOrFinishedWagers, 'Failed to validate campaign wagers'), runCampaignEligibilityCheck(hasCampaignRecord, 'Failed to retrieve campaign subscription data from object store')]);
  if (userHasWagers || userHasCampaignRecord) {
    showCampaignNotAvailableDialog();
    return false;
  }
  return true;
};
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  ensureNewCustomerCampaignEligibility
});

 })(window);